import {
  Checkbox,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from '@material-ui/core';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FaArrowCircleRight, FaInfo, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ConfiguracaoEtapasContext } from 'views/pages/ConfiguracaoEtapas';
import {
  Table,
  Button,
  Input,
  Row,
  Col,
  Badge,
  Modal,
  CardHeader,
  ModalBody,
  Card,
} from 'reactstrap';

import api from 'services/api';
import Swal from 'sweetalert2';

interface Props {
  orcamentoProduto: any;
  configuracaoId: number;
  setConfiguracoesAlternadas: any;
}

interface Response {
  id: number;
  alternadoId: number;
  areaTotalIrrigadaEmHectares: number;
  comprimentoCasaMaquinaCentro: number;
  configuracaoId: number;
  desnivelCaptacaoCentroPivo: number;
  incluirAspersorFinal: string;
  isConcluido: boolean;
  concluidoEngenharia: boolean;
  isPrincipal: boolean;
  laminaBruta: number;
  tempoOperacaoDiaria: number;
  acoes: string | null;
  laminaSecundaria: number | null;
  numeroPivo: number;
  vazaoAtual: number;
}

export default function TabelaAlternado({
  orcamentoProduto,
  configuracaoId,
  setConfiguracoesAlternadas,
}: Props): JSX.Element {
  const { orcamento } = useContext(ConfiguracaoEtapasContext);
  const isOrcamentoInativo = orcamento?.status === 'I';

  const [linhas, setLinhas] = useState<any[]>([]);
  const [idBusca, setIdBusca] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [dadosTabela, setDadosTabela] = useState<Response[]>([]);
  const [acessoLimitado, setAcessoLimitado] = useState(
    {} as ValidarAcessoPrograma,
  );
  const [acessoLimitadoConcluir, setAcessoLimitadoConcluir] = useState(
    {} as ValidarAcessoPrograma,
  );
  const [mostrarAcoes, setMostrarAcoes] = useState(false);
  const [configSelecionadaAcao, setConfigSelecionadaAcao] = useState<
    number | null
  >(null);
  const [isAtualizando, setIsAtualizando] = useState(false);
  const [mostrarBtnConcluidoEngenharia, setMostrarBtnConcluidoEngenharia] =
    useState(false);

  async function pegarDadosTabela() {
    const response = await api.get<Response[]>(`/alternado/${configuracaoId}`);

    setDadosTabela(response.data);
    setConfiguracoesAlternadas(response.data);
    console.log('setConfiguracoesAlternadas: ', response.data);
  }

  async function getAcessoConcluidoEngenharia() {
    const response = await api.get(
      '/acesso-programa/acesso-concluido-engenharia',
    );

    const acessoConcluidoEngenharia: boolean = response.data;

    setMostrarBtnConcluidoEngenharia(acessoConcluidoEngenharia);
  }

  useEffect(() => {
    getAcessoConcluidoEngenharia();
  }, []);

  const buscarDados = async () => {
    if (isOrcamentoInativo) {
      Swal.fire({
        icon: 'error',
        title: 'Operação bloqueada',
        text: 'Não é permitido alternar uma configuração inativa.',
      });
      return;
    }

    if (!idBusca) return;

    if (Number(idBusca) === configuracaoId) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: 'Não é possível alternar utilizando a mesma configuração',
      });
      return;
    }

    setIsLoading(true);

    try {
      const response = await api.post(`/alternado/${idBusca}`, {
        id: idBusca,
        configuracaoId,
      });
      if (response.data) {
        const data = await response.data;

        // Verifica se a API retornou um array ou um único objeto
        const novosDados = Array.isArray(data) ? data : [data];

        setLinhas(novosDados);
        console.log('novosDados: ', novosDados);
        setIdBusca('');
        await pegarDadosTabela();
        setIsLoading(false);
      } else {
        console.error('Erro ao buscar dados:', response.status);
        setIdBusca('');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      setIdBusca('');
      setIsLoading(false);
    }
  };

  const excluirItem = async (
    id: number,
    configuracaoIdV: number,
    alternadoId: number,
  ) => {
    setIsLoading(true);
    try {
      // Faça a requisição para excluir o item
      await api.delete(
        `/alternado/${id}?configuracaoId=${configuracaoIdV}&alternadoId=${alternadoId}`,
      );
      await pegarDadosTabela();
      setIsLoading(false);
    } catch (error) {
      console.error('Erro ao excluir item:', error);
      setIsLoading(false);
    }
  };

  function mensagemExcluir(
    id: number,
    configuracaoIdV: number,
    alternadoId: number,
  ) {
    Swal.fire({
      title: `Excluir configuração?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, excluir`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(result => {
      if (result.isConfirmed) {
        excluirItem(id, configuracaoIdV, alternadoId);
      }
    });
  }

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 113,
      },
    });
    setAcessoLimitado(response.data);

    const response2 = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 119,
      },
    });
    setAcessoLimitadoConcluir(response2.data);
  }

  useEffect(() => {
    pegarDadosTabela();
    getAcessoLimitadoPrograma();
  }, []);

  async function mudarPrincipal(
    configId: number | null,
    alternadoId: number | undefined,
  ) {
    if (isOrcamentoInativo) {
      Swal.fire({
        icon: 'error',
        title: 'Operação bloqueada',
        text: 'Não é permitido alterar o pivô principal de uma configuração inativa.',
      });
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post(`/alternado/alterar-principal`, {
        configuracaoId,
        principalConfigId: configId,
        alternadoId,
      });

      // await pegarDadosTabela();

      setDadosTabela(response.data);
      setConfiguracoesAlternadas(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  function mensagemMudarPrincipal(
    configId: number | null,
    alternadoId: number | undefined,
  ) {
    Swal.fire({
      title: `Trocar o principal para a configuração #${configId}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, mudar`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(result => {
      if (result.isConfirmed) {
        mudarPrincipal(configId, alternadoId);
      }
    });
  }

  async function handleCheckbox({
    id,
    checked,
  }: {
    id: number;
    checked: boolean;
  }) {
    if (isOrcamentoInativo) {
      Swal.fire({
        icon: 'error',
        title: 'Operação bloqueada',
        text: 'Não é permitido alterar uma configuração inativa.',
      });
      return;
    }

    const resultado = await Swal.fire({
      title: checked
        ? `Deseja definir esse registro como concluído? Em caso de reprocessamento dos alternados, essa ação deverá ser feita novamente`
        : `Deseja desmarcar o registro que estava concluído?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, prosseguir`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Fechar`,
    });

    if (resultado.isConfirmed) {
      const toastId = toast.loading(`Salvando. Aguarde`);

      await api.put(`/orcamento/${configuracaoId}/alternado-concluir`, {
        id,
        checked,
      });

      toast.dismiss(toastId);

      toast.success(`Concluído`);

      setDadosTabela(
        dadosTabela.map(item => {
          return {
            ...item,
            concluidoEngenharia:
              item.id === id ? checked : item.concluidoEngenharia,
          };
        }),
      );
    }
  }

  async function atualizarDados() {
    if (isOrcamentoInativo) {
      Swal.fire({
        icon: 'error',
        title: 'Operação bloqueada',
        text: 'Não é permitido reprocessar dados de uma configuração inativa.',
      });
      return;
    }

    setIsAtualizando(true);

    const toastId = toast.loading('Atualizando dados');

    await api.put(`/orcamento/${configuracaoId}/alternado-reprocessar`, {});

    await pegarDadosTabela();
    toast.dismiss(toastId);
    toast.success('Dados atualizados');
    setIsAtualizando(false);
  }

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="lg"
        isOpen={mostrarAcoes}
        toggle={() => setMostrarAcoes(!mostrarAcoes)}
      >
        <CardHeader className="bg-transparent">
          <h3 className="mb-0">Ações a serem tomadas</h3>
        </CardHeader>
        <ModalBody>
          <Table className="align-items-center table-flush mb-4" responsive>
            <thead className="thead-light">
              <tr>
                <th>Config</th>
                <th>Ação</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {dadosTabela
                .filter(item => item.configuracaoId === configSelecionadaAcao)
                .map((linha, index) => (
                  <tr key={index}>
                    <td className="py-1">{linha.configuracaoId}</td>
                    <td
                      className="py-1"
                      style={{
                        whiteSpace: 'pre',
                        wordWrap: 'break-word',
                      }}
                    >
                      <div
                        style={{
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'keep-all',
                        }}
                      >
                        {linha.acoes ?? 'Nenhuma ação a ser realizada'}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
      <div style={{ width: '100%' }}>
        <Row className="d-flex mb-3">
          <Col sm="2">
            <Input
              type="text"
              placeholder="Nº da configuração"
              value={idBusca}
              size={30}
              disabled={isLoading || isOrcamentoInativo}
              onChange={e => setIdBusca(e.target.value)}
            />
          </Col>

          <Col sm="2">
            <Button
              color="primary"
              className=""
              disabled={isLoading || isOrcamentoInativo}
              onClick={buscarDados}
            >
              Alternar
            </Button>
          </Col>

          <Col sm="2">
            <FormControl
              className="w-75"
              variant="outlined"
              hidden={!acessoLimitado.temAcesso}
            >
              <InputLabel className="mt--2">Pivô Principal</InputLabel>
              <Select
                label="Principal"
                disabled={isLoading || isOrcamentoInativo}
                value={
                  dadosTabela.find(item => item.isPrincipal)?.configuracaoId ||
                  ''
                }
                onChange={event =>
                  mensagemMudarPrincipal(
                    event.target.value ? Number(event.target.value) : null,
                    dadosTabela.find(item => item.isPrincipal)?.alternadoId,
                  )
                }
              >
                <MenuItem value={undefined}>Selecione...</MenuItem>
                {dadosTabela.map(questaoItem => {
                  return (
                    <MenuItem
                      key={questaoItem.configuracaoId}
                      value={questaoItem.configuracaoId}
                    >
                      {questaoItem.configuracaoId}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Col>
          <Col hidden={dadosTabela.length === 0} sm="2">
            <Button
              color="success"
              className=""
              disabled={isLoading || isAtualizando || isOrcamentoInativo}
              onClick={atualizarDados}
            >
              {isAtualizando ? 'Atualizando' : 'Atualizar'}
            </Button>
          </Col>
          <Col xs={12}>
            <small className="mt-2">
              Alternado{' '}
              <span className="font-weight-bold">
                #{dadosTabela.length > 0 && dadosTabela[0].alternadoId}
              </span>
            </small>
          </Col>
        </Row>

        <Table className="align-items-center table-flush mb-4" responsive>
          <thead className="thead-light">
            <tr>
              <th>Tag Pivo</th>
              <th>Config</th>
              <th>Principal</th>
              <th>Vazão Atual</th>
              <th>Lâmina Bruta Atual</th>
              <th
                className="text-center"
                hidden={!acessoLimitadoConcluir.temAcesso}
              >
                Concluído?
              </th>
              <th> </th>
              <th> </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={8} className="text-center py-5">
                  <CircularProgress />
                </td>
              </tr>
            ) : (
              dadosTabela.map((linha, index) => (
                <tr key={index}>
                  <td className="py-1">{linha.numeroPivo}</td>
                  <td className="py-1">
                    {linha.configuracaoId}{' '}
                    {linha.configuracaoId === configuracaoId ? (
                      ''
                    ) : (
                      <Link
                        className="ml-2"
                        to={{
                          pathname: `/admin/etapas-orcamento`,
                          state: {
                            orcamentoVersaoId: linha.configuracaoId,
                          },
                        }}
                      >
                        <FaArrowCircleRight size={15} />
                      </Link>
                    )}
                  </td>
                  <td className="py-1">
                    {linha.isPrincipal ? (
                      <Badge color="success">Sim</Badge>
                    ) : (
                      <Badge color="warning">Não</Badge>
                    )}
                  </td>
                  <td className="py-1">{linha.vazaoAtual} m³/h</td>
                  <td className="py-1">{linha.laminaBruta} mm/dia</td>

                  <td
                    className="py-1 text-center"
                    hidden={!acessoLimitadoConcluir.temAcesso}
                  >
                    <Checkbox
                      disabled={
                        !mostrarBtnConcluidoEngenharia || isOrcamentoInativo
                      }
                      checked={linha.concluidoEngenharia}
                      color="primary"
                      onChange={event =>
                        handleCheckbox({
                          id: linha.id,
                          checked: event.target.checked,
                        })
                      }
                      className="mr-1"
                      title="Marcar esse registro como concluído"
                    />
                  </td>
                  <td className="py-1">
                    <Tooltip title="Mostrar ações a tomar">
                      <Button
                        size="sm"
                        color="info"
                        type="button"
                        className="btn-icon btn-2 ml-1"
                        onClick={() => {
                          setMostrarAcoes(true);
                          setConfigSelecionadaAcao(linha.configuracaoId);
                        }}
                      >
                        <FaInfo />
                      </Button>
                    </Tooltip>
                    {linha.configuracaoId === configuracaoId ||
                    isOrcamentoInativo ? (
                      <> </>
                    ) : (
                      <Tooltip title="Excluir configuração do alternado">
                        <Button
                          size="sm"
                          color="danger"
                          type="button"
                          className="btn-icon btn-2 ml-1"
                          onClick={() =>
                            mensagemExcluir(
                              linha.id,
                              linha.configuracaoId,
                              linha.alternadoId,
                            )
                          }
                        >
                          <FaTrash />
                        </Button>
                      </Tooltip>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
}
